import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getDpcdDataAsync } from 'src/services/costModelling/shouldCostLibrary.services'

const initialState = {
  dpcdModelLoader: false,
  dpcdModelData: [],
  modelDetailsError: '',
}

export const getDpcdModelDataSlice = createSlice({
  name: 'get-models-details-data',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getDpcdDataAsync.pending), (state) => {
      state.dpcdModelLoader = true
    })
    builder.addMatcher(isAnyOf(getDpcdDataAsync.fulfilled), (state, action) => {
      state.dpcdModelLoader = false
      state.dpcdModelData = action.payload.data
      state.commodityLastUpdatedDate = action.payload.last_updated_date
    })
    builder.addMatcher(isAnyOf(getDpcdDataAsync.rejected), (state, action) => {
      state.dpcdModelLoader = false
      state.modelDetailsError = action.payload.message
    })
  },
  reducers: {
    resetDpcdModelDataSlice: () => initialState,
  },
})

export const { resetDpcdModelDataSlice } = getDpcdModelDataSlice.actions

export default getDpcdModelDataSlice.reducer
